import { type MantineColorsTuple } from '@mantine/core';

export const paletteColorBrand: MantineColorsTuple = [
  '#eef4fb',
  '#e0ebfa',
  '#bfd5f2',
  '#6da7f3',
  '#4b93f2',
  '#2173de',
  '#1c69ce',
  '#125ab2',
  '#124187',
  '#0c3366',
];

export const paletteColorBase: MantineColorsTuple = [
  '#f9fafc',
  '#f3f4f7',
  '#e5e7ed',
  '#d0d4dd',
  '#98a2b3',
  '#657084',
  '#475368',
  '#334055',
  '#192231',
  '#111727',
];

export const paletteColorSuccess: MantineColorsTuple = [
  '#e8fdea',
  '#d5f6d8',
  '#95ea9c',
  '#64d86e',
  '#41c84d',
  '#1eb32b',
  '#14991f',
  '#137213',
  '#045804',
  '#074b07',
];

export const paletteColorWarn: MantineColorsTuple = [
  '#fff7f0',
  '#fff2e5',
  '#ffd6ad',
  '#ffba6b',
  '#ffa238',
  '#f8860d',
  '#de710b',
  '#b04c09',
  '#913c0a',
  '#733009',
];

export const paletteColorFail: MantineColorsTuple = [
  '#fef3f2',
  '#feedeb',
  '#fddfdd',
  '#fda29b',
  '#f97066',
  '#e5443e',
  '#d12b1f',
  '#b5201a',
  '#9c1b10',
  '#661c13',
];

export const paletteLavender: MantineColorsTuple = [
  '#F5F3FF',
  '#ECE9FE',
  '#DDD6FE',
  '#C3B5FD',
  '#A48AFB',
  '#875BF7',
  '#7839EE',
  '#6927DA',
  '#5720B7',
  '#491C96',
];

export const paletteYellow: MantineColorsTuple = [
  '#FFFBEA',
  '#FFF3C4',
  '#FCE588',
  '#FADB5F',
  '#F7C948',
  '#F0B429',
  '#DE911D',
  '#CB6E17',
  '#B44D12',
  '#8D2B0B',
];

export const paletteLime: MantineColorsTuple = [
  '#F8FEE7',
  '#F3FBDA',
  '#E5F8AB',
  '#CDEF67',
  '#B7E13A',
  '#A2CC25',
  '#8EB812',
  '#70900E',
  '#536913',
  '#435314',
];

export const paletteMoss: MantineColorsTuple = [
  '#F1FBE9',
  '#DFEDD5',
  '#C8E0B1',
  '#97BB74',
  '#79A750',
  '#5D9330',
  '#4A7327',
  '#36541E',
  '#253815',
  '#212B17',
];

export const paletteBrown: MantineColorsTuple = [
  '#F9F4EE',
  '#F4EADE',
  '#E9D5BF',
  '#E0C19F',
  '#D1AA81',
  '#C49564',
  '#A07951',
  '#775B3D',
  '#54412C',
  '#3B2E20',
];

export const paletteAqua: MantineColorsTuple = [
  '#ECFDFF',
  '#CFF9FE',
  '#A5F0FC',
  '#79E9FC',
  '#22CCEE',
  '#06AED4',
  '#088AB2',
  '#0E7090',
  '#155B75',
  '#164C63',
];

export const paletteFuchsia: MantineColorsTuple = [
  '#FFF0FE',
  '#FFE5FD',
  '#FCB5F8',
  '#FF80F7',
  '#F764ED',
  '#E52ED8',
  '#D017C3',
  '#B009A5',
  '#910A88',
  '#73096C',
];

export const paletteElectric: MantineColorsTuple = [
  '#EAEEFA',
  '#D0D8F5',
  '#9BAEF2',
  '#6A88F2',
  '#4B6FF2',
  '#315AF2',
  '#1F47E0',
  '#1234B2',
  '#112B8C',
  '#0C1F66',
];

export const paletteMinistry: MantineColorsTuple = [
  '#F1F9F6',
  '#E4F2ED',
  '#BFE1D4',
  '#92CCB6',
  '#5CB292',
  '#1C9467',
  '#187652',
  '#146B4B',
  '#10553C',
  '#0D432F',
];

export const paletteColorCalendar: MantineColorsTuple = [
  paletteColorBrand[5],
  paletteLavender[5],
  paletteFuchsia[5],
  paletteYellow[5],
  paletteLime[5],
  paletteMoss[5],
  paletteBrown[5],
  paletteAqua[5],
  '',
  '',
];

export const paletteColorCalendarBg: MantineColorsTuple = [
  paletteColorBrand[0],
  paletteLavender[0],
  paletteFuchsia[0],
  paletteYellow[0],
  paletteLime[0],
  paletteMoss[0],
  paletteBrown[0],
  paletteAqua[0],
  '',
  '',
];

export const paletteColorCalendarBgHover: MantineColorsTuple = [
  paletteColorBrand[1],
  paletteLavender[1],
  paletteFuchsia[1],
  paletteYellow[1],
  paletteLime[1],
  paletteMoss[1],
  paletteBrown[1],
  paletteAqua[1],
  '',
  '',
];

export const paletteColorCalendarText: MantineColorsTuple = [
  paletteColorBrand[7],
  paletteLavender[7],
  paletteFuchsia[7],
  paletteYellow[7],
  paletteLime[7],
  paletteMoss[7],
  paletteBrown[7],
  paletteAqua[7],
  '',
  '',
];
